var graduates = document.getElementById('graduate-scroller'),
scroller = document.getElementById('graduate-container'),
graduateWidth = graduates.offsetWidth, // inside
scrollerWidth = scroller.offsetWidth, // outside
center = (graduateWidth - scrollerWidth) / 2;

scroller.scrollLeft = center;

function myFunction(x) {
if (x.matches) { // If media query matches
    $(function() {
        $('.marquee').marquee({
            duplicated: true,
            duration: 35000, // Duration of the animation
            gap: 0, // Space in pixels between the tickers
            pauseOnCycle: false, // On cycle pause the marquee
            pauseOnHover: true, // Pause on hover
            startVisible: true // The marquee is visible initially positioned next to the border towards it will be moving
        });
    });
} else {
    $(function() {
        $('.marquee').marquee({
            duplicated: true,
            duration: 55000, // Duration of the animation
            gap: 0, // Space in pixels between the tickers
            pauseOnCycle: false, // On cycle pause the marquee
            pauseOnHover: true, // Pause on hover
            startVisible: true // The marquee is visible initially positioned next to the border towards it will be moving
        });
    });
}
}

var x = window.matchMedia("(max-width: 700px)")
myFunction(x) // Call listener function at run time
x.addListener(myFunction) // Attach listener function on state changes